// extracted by mini-css-extract-plugin
export default {"row":"PalletsPricingPerAddressInnerFormTableRow_row__OTdCG","cell":"PalletsPricingPerAddressInnerFormTableRow_cell__7lWWo"};